export const GET_ALL_DNS_MANAGEMENT_RECORDS = "DNS_MANAGEMENT/GET_ALL_DNS_MANAGEMENT_RECORDS";
export const SAVE_ALL_DNS_MANAGEMENT_RECORDS = "DNS_MANAGEMENT/SAVE_ALL_DNS_MANAGEMENT_RECORDS";
export const UPDATE_CUSTOM_RECORDS = "DNS_MANAGEMENT/UPDATE_CUSTOM_RECORDS";
export const DELETE_CUSTOM_RECORDS = "DNS_MANAGEMENT/DELETE_CUSTOM_RECORDS";
export const UPDATE_ADD_CUSTOM_RECORDS = "DNS_MANAGEMENT/UPDATE_ADD_CUSTOM_RECORDS";
export const UPDATE_NAME_SERVERS = "DNS_MANAGEMENT/UPDATE_NAME_SERVERS";
